import styled from 'styled-components';
import { fonts, colors } from '../../css';

export const NumberToggleWrapper = styled.div`
  min-width: 20px;
  max-width: 90px;
  display: inline-block;
  position: relative;
  text-align: center;
`;
export const NumberToggleUp = styled.button`
  width: 30px;
  height: 30px;
  margin-bottom: 5px;
  position: relative;
  color: ${colors.colorGrey02};
  cursor: pointer;

  &:before,
  &:after {
    content: '';
    width: 65%;
    height: 2px;
    display: block;
    position: absolute;
    bottom: 50%;
    right: 50%;
    transform: translate(50%, 50%);
    background: ${colors.colorGrey03};
  }
  &:after {
    content: '';
    width: 2px;
    height: 65%;
  }

  &.disabled:before,
  &.disabled:after {
    background: ${colors.colorGrey04};
  }
`;
export const NumberToggleInput = styled.input`
  width: 100%;
  height: calc(100% - 70px);
  position: absolute;
  display: block;
  overflow: visible;
  font-family: ${fonts.fontBold};
  font-size: 40px;
  line-height: 40px;
  text-align: center;
  -moz-appearance: textfield;
  color: transparent;
  background: transparent;
  border: none;

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }
`;

export const NumberToggleInputClone = styled.div`
  width: 100%;
  padding-top: 0.2em;
  font-family: ${fonts.fontBold};
  font-size: 40px;
  line-height: 40px;

  &.disabled {
    color: ${colors.colorGrey03};
  }
`;
export const NumberToggleDown = styled.button`
  width: 30px;
  height: 30px;
  margin-top: 5px;
  position: relative;
  color: ${colors.colorGrey02};
  cursor: pointer;

  &:before {
    content: '';
    width: 65%;
    height: 2px;
    display: block;
    position: absolute;
    bottom: 50%;
    right: 50%;
    transform: translate(50%, 50%);
    background: ${colors.colorGrey03};
  }

  &.disabled:before {
    background: ${colors.colorGrey04};
  }
`;
